import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import { logFetchValidateError } from "@utils/validate";
import { number, object } from "yup";

export interface ApplyDietitianCouponRequest {
  code: string;
}

export interface ApplyDietitianCouponResponse {
  id: number;
}

const applyDietitianCouponResponseSchema = object({
  data: object({
    id: number().defined(),
  }).defined(),
});

export const postApplyDietitianCoupon = async (
  payload: ApplyDietitianCouponRequest,
): Promise<ApiResponse<ApplyDietitianCouponResponse>> => {
  const response = await fetchData(
    "/dietitian/subscription/coupons",
    APIMethods.POST,
    payload,
  );

  return await applyDietitianCouponResponseSchema
    .validate(response)
    .catch(logFetchValidateError("/dietitian/subscription/coupons"));
};
